import React from 'react';

import classNames from 'classnames';

import { STATUS_CLASSES, STATUS_LABEL, UNKNOWN_STATUS_CLASSES } from '../constants';
import { RequestStatus } from '../types';

type StatusBadgeProps = {
  status: RequestStatus;
};

// A status the frontend doesn't know about is still a status: degrade to the
// raw value in a neutral pill rather than an empty, colourless one. The type
// says this can't happen, but the value comes off the wire — a backend that
// gains a status before this bundle ships would otherwise render nothing at all.
const StatusBadge: React.FC<StatusBadgeProps> = ({ status }: StatusBadgeProps) => (
  <span
    className={classNames(
      'inline-block px-2 py-0.5 text-xs font-medium rounded',
      STATUS_CLASSES[status] ?? UNKNOWN_STATUS_CLASSES
    )}
  >
    {STATUS_LABEL[status] ?? status}
  </span>
);

export default StatusBadge;
